import type { DateRange } from "../../../../../shared/components/DurationSelector/types";

export const calculateGranularity = (
  dateRange: DateRange
): "hourly" | "daily" | "weekly" | "monthly" => {
  const [startDate, endDate] = dateRange;

  if (!startDate || !endDate) {
    return "daily";
  }

  const daysDiff = endDate.diff(startDate, "day", true);
  const monthsDiff = endDate.diff(startDate, "month", true);

  if (daysDiff <= 2) {
    return "hourly";
  }

  if (monthsDiff > 6) {
    return "monthly";
  }

  if (monthsDiff > 2) {
    return "weekly";
  }

  return "daily";
};
